import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTotalFollowers = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 63.29036 63.29764",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "totalFollowers" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.99805,44.10244v5.22s-5.71,7.67-19.31,7.5c-13.61.17-19.33-7.5-19.33-7.5v-5.22c2-3.61,13.35-6.9,13.35-6.9v-5.75a16.23936,16.23936,0,0,1-2.99-7.53l-.74-4.23v-3.51a9.71,9.71,0,0,1,19.42,0v3.51l-.7,4.24a16.58709,16.58709,0,0,1-3.04,7.52v5.75S49.01807,40.4924,50.99805,44.10244Z",
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M39.7073,37.52958c1.23081-.4267,2.08506-.67432,2.08506-.67432V32.25162a11.01925,11.01925,0,0,1-1.86745-3.65515",
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}), /* @__PURE__ */ _jsx("path", {
			d: "M41.76743,13.92158A7.77325,7.77325,0,0,1,54.3543,20.02593v2.81023l-.56045,3.39468a13.28023,13.28023,0,0,1-2.43391,6.02078v4.60364s9.09518,2.63407,10.68042,5.52439v4.17929s-4.16262,5.59149-14.00442,5.98517",
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M23.58307,37.52958c-1.23082-.4267-2.08506-.67432-2.08506-.67432V32.25162a11.01944,11.01944,0,0,0,1.86745-3.65515",
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}), /* @__PURE__ */ _jsx("path", {
			d: "M21.52294,13.92158A7.77326,7.77326,0,0,0,8.93606,20.02593v2.81023l.56046,3.39468a13.28009,13.28009,0,0,0,2.43391,6.02078v4.60364S2.83524,39.48933,1.25,42.37965v4.17929s4.16262,5.59149,14.00443,5.98517",
			style: {
				fill: "none",
				stroke: "#2b3273",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})] })
	]
});
export default SvgTotalFollowers;
